import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useGetPermissionsQuery = (userId?: string) => {
  const { data } = useQuery([API_URL.PERMISSIONS, userId], () =>
    userId ? api.get(API_URL.PERMISSIONS) : null
  );

  return { permissions: data?.data };
};

export default useGetPermissionsQuery;
